import { api } from '@/fsd/shared/api';
import { transformShipmentsListFilters } from '../../lib/helpers/transformShipmentsListFilters';

interface IPrams {
  filters?: any;
  sorted?: any;
  metaData: any;
}

export const fetchShipmentList = async ({
  filters = {},
  sorted = {},
  metaData,
}: IPrams) => {
  const transformedFilters = transformShipmentsListFilters(filters);

  const requestData = {
    sorted,
    filters: transformedFilters,
    paginator: {
      page_current: metaData.current_page,
      page_size: metaData.page_size,
    },
  };

  // delete requestData.id;
  // delete requestData.user;
  // requestData.shipping_method = String(requestData.shipping_method);

  const json = await api.post(`/api/v1/purchase/shipment/list/`, {
    body: requestData,
  });

  return {
    data: json.data.length > 0 ? json.data : [],
    meta: json.meta,
  };
};
